export default {
  yes: 'yes',
  no: 'no',
  dont_know: 'dont_know'
} as const
